import { OPEN_SPACE_SELECTOR } from '../actions';

const openSpaceSelector = () => (dispatch) => {
  dispatch({
    type: OPEN_SPACE_SELECTOR,
  });
};

export default openSpaceSelector;
